import { render } from "./org-type.html?vue&type=template&id=5f1f473e&scoped=true&ts=true"
import script from "./org-type.ts?vue&type=script&lang=ts"
export * from "./org-type.ts?vue&type=script&lang=ts"

import "./org-type.scss?vue&type=style&index=0&id=5f1f473e&lang=scss&scoped=true"

import exportComponent from "D:\\DEV\\Vue\\work\\vue_sotec_main\\vue_sotec_main\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f1f473e"]])

export default __exports__